export const doorTypeURLs = {
  'Interior Doors': '/services/c/door-window-specialist/893e44520',
  'Exterior Doors': '/services/c/door-window-specialist/893e44520',
  'Patio Doors': '/services/c/door-window-specialist/893e44520',
  Windows: '/services/c/door-window-specialist/893e44520'
};